import { apiCall, ApiConfig } from '../../config/api'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'
import { getProductOriginsAction } from '../actions/productOriginsActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { GET_PRODUCTORIGINS } from '../types/productOriginsTypes'
import { DataGridElements } from '../../interfaces/index'

/*
Copyright 2022-07-12 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se módifica saga para solo obtener los productOrigins activos
*/

export function* getProductOriginsAsync() {
  try {
    const { status, data }: AxiosResponse<DataGridElements<ProductOrigin>> =
      yield call(
        apiCall,
        'GET',
        `${ApiConfig.ProductOriginApi}?pageSize=50&active=true`
      )
    if (status === 200) {
      yield put(getProductOriginsAction(data.items))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getProductOriginsAction([], serverError.message))
  }
}

export function* watchGetProductOriginsAsync() {
  yield takeEvery(GET_PRODUCTORIGINS, getProductOriginsAsync)
}
